export const getSpecies = ({ search }) => search.species;

export const getPathogens = ({ search }) => search.pathogens;

export const getBehaviors = ({ search }) => search.behaviors;

export const getTreatments = ({ search }) => search.treatments;

export const getMiscDetails = ({ search }) => search.details;
